import type { Loyalty } from '@aviata/platform-types';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';

export async function getLoyaltyCustomer() {
  try {
    const response = await api.loyalty.customer();
    return response.data as Loyalty.Customer.Response;
  } catch (cause) {
    sentryModel.logBaseError({
      error: cause as Error,
      description: 'Payment error: failed to get loyalty customer',
    });
    throw cause;
  }
}

export async function applyLoyaltyCashback({ billId }: { billId: string }) {
  try {
    const response = await api.client.post(
      '/loyalty/api/external/v2/customer/cashbacks/apply',
      {
        bill_id: billId,
      },
    );
    return response.data;
  } catch (cause) {
    sentryModel.logBaseError({
      error: cause as Error,
      description: 'Payment error: failed to apply loyalty cashback',
    });
    throw cause;
  }
}

export async function cancelLoyaltyCashback({
  applicationId,
}: {
  applicationId: string;
}) {
  try {
    const response = await api.loyalty.cancelCashback(applicationId);
    return response.data;
  } catch (cause) {
    sentryModel.logBaseError({
      error: cause as Error,
      description: 'Payment error: failed to cancel loyalty cashback',
    });
    throw cause;
  }
}
